export const IllustNoGoods = ({ width = '100%' }: JSX.IntrinsicElements['svg']) => (
  <svg width='121' height='91' viewBox='0 0 121 91' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M6.34521 59.0064L60.4998 90.3439L114.658 59.0064L60.4998 28.4258L6.34521 59.0064Z' fill='#B5B5B5' />
    <path
      style={{ mixBlendMode: 'multiply' }}
      d='M6.34521 59.0064L60.4998 90.3439L114.658 59.0064L60.4998 28.4258L6.34521 59.0064Z'
      fill='url(#paint0_linear_1870_1774)'
    />
    <path d='M120.436 55.6605L60.5 21.8179V28.4294L114.658 59.0066L120.436 55.6605Z' fill='#DDDDDD' />
    <path
      style={{ mixBlendMode: 'screen' }}
      d='M120.436 55.6605L60.5 21.8179V28.4294L114.658 59.0066L120.436 55.6605Z'
      fill='url(#paint1_linear_1870_1774)'
    />
    <path
      opacity='0.44'
      d='M120.436 55.6605L60.5 21.8179V28.4294L114.658 59.0066L120.436 55.6605Z'
      fill='url(#paint2_linear_1870_1774)'
    />
    <path d='M60.4999 21.8179L0.563965 55.6605L6.34531 59.0066L60.4999 28.4259V28.4294V21.8179Z' fill='#DDDDDD' />
    <path
      style={{ mixBlendMode: 'screen' }}
      d='M60.4999 21.8179L0.563965 55.6605L6.34531 59.0066L60.4999 28.4259V28.4294V21.8179Z'
      fill='url(#paint3_linear_1870_1774)'
    />
    <path
      opacity='0.23'
      d='M60.4999 21.8179L0.563965 55.6605L6.34531 59.0066L60.4999 28.4259V28.4294V21.8179Z'
      fill='url(#paint4_linear_1870_1774)'
    />
    <path
      d='M72.8168 54.7039C73.1062 54.1921 73.5827 53.8121 74.1465 53.6436C74.7103 53.4751 75.3175 53.5311 75.8408 53.8V45.2018L73.6798 43.9825C73.1682 43.6854 72.7922 43.2012 72.6315 42.6323C72.4707 42.0634 72.5377 41.4544 72.8183 40.9339C73.0989 40.4135 73.5711 40.0224 74.1351 39.8433C74.6991 39.6642 75.3108 39.7111 75.8408 39.9742V31.376L73.6798 30.1567C73.1481 29.8705 72.752 29.3851 72.5786 28.8072C72.4053 28.2292 72.4689 27.6062 72.7554 27.0752C73.042 26.5441 73.528 26.1485 74.1067 25.9753C74.6853 25.8022 75.3091 25.8657 75.8408 26.1519V17.5502L73.6798 16.3309C73.1481 16.0447 72.752 15.5593 72.5786 14.9814C72.4053 14.4035 72.4689 13.7805 72.7554 13.2494C73.042 12.7183 73.528 12.3227 74.1067 12.1496C74.6853 11.9764 75.3091 12.04 75.8408 12.3262V2.27743C75.8408 1.67342 75.6006 1.09415 75.1729 0.667046C74.7453 0.239944 74.1653 0 73.5605 0C72.9558 0 72.3758 0.239944 71.9481 0.667046C71.5205 1.09415 71.2803 1.67342 71.2803 2.27743V84.1073L75.8408 81.4655V72.8533L73.6798 71.634C73.1682 71.3369 72.7922 70.8527 72.6315 70.2838C72.4707 69.715 72.5377 69.1059 72.8183 68.5855C73.0989 68.065 73.5711 67.6739 74.1351 67.4948C74.6991 67.3157 75.3108 67.3627 75.8408 67.6257V59.0275L73.6798 57.8082C73.419 57.6611 73.1898 57.464 73.0052 57.2283C72.8207 56.9926 72.6845 56.723 72.6043 56.4347C72.5242 56.1464 72.5017 55.8452 72.5381 55.5482C72.5746 55.2512 72.6693 54.9643 72.8168 54.7039Z'
      fill='#999999'
    />
    <path
      d='M72.8168 54.7039C73.1062 54.1921 73.5827 53.8121 74.1465 53.6436C74.7103 53.4751 75.3175 53.5311 75.8408 53.8V45.2018L73.6798 43.9825C73.1682 43.6854 72.7922 43.2012 72.6315 42.6323C72.4707 42.0634 72.5377 41.4544 72.8183 40.9339C73.0989 40.4135 73.5711 40.0224 74.1351 39.8433C74.6991 39.6642 75.3108 39.7111 75.8408 39.9742V31.376L73.6798 30.1567C73.1481 29.8705 72.752 29.3851 72.5786 28.8072C72.4053 28.2292 72.4689 27.6062 72.7554 27.0752C73.042 26.5441 73.528 26.1485 74.1067 25.9753C74.6853 25.8022 75.3091 25.8657 75.8408 26.1519V17.5502L73.6798 16.3309C73.1481 16.0447 72.752 15.5593 72.5786 14.9814C72.4053 14.4035 72.4689 13.7805 72.7554 13.2494C73.042 12.7183 73.528 12.3227 74.1067 12.1496C74.6853 11.9764 75.3091 12.04 75.8408 12.3262V2.27743C75.8408 1.67342 75.6006 1.09415 75.1729 0.667046C74.7453 0.239944 74.1653 0 73.5605 0C72.9558 0 72.3758 0.239944 71.9481 0.667046C71.5205 1.09415 71.2803 1.67342 71.2803 2.27743V84.1073L75.8408 81.4655V72.8533L73.6798 71.634C73.1682 71.3369 72.7922 70.8527 72.6315 70.2838C72.4707 69.715 72.5377 69.1059 72.8183 68.5855C73.0989 68.065 73.5711 67.6739 74.1351 67.4948C74.6991 67.3157 75.3108 67.3627 75.8408 67.6257V59.0275L73.6798 57.8082C73.419 57.6611 73.1898 57.464 73.0052 57.2283C72.8207 56.9926 72.6845 56.723 72.6043 56.4347C72.5242 56.1464 72.5017 55.8452 72.5381 55.5482C72.5746 55.2512 72.6693 54.9643 72.8168 54.7039Z'
      fill='url(#paint5_linear_1870_1774)'
    />
    <path
      style={{ mixBlendMode: 'multiply' }}
      opacity='0.4'
      d='M72.8168 54.7039C73.1062 54.1921 73.5827 53.8121 74.1465 53.6436C74.7103 53.4751 75.3175 53.5311 75.8408 53.8V45.2018L73.6798 43.9825C73.1682 43.6854 72.7922 43.2012 72.6315 42.6323C72.4707 42.0634 72.5377 41.4544 72.8183 40.9339C73.0989 40.4135 73.5711 40.0224 74.1351 39.8433C74.6991 39.6642 75.3108 39.7111 75.8408 39.9742V31.376L73.6798 30.1567C73.1481 29.8705 72.752 29.3851 72.5786 28.8072C72.4053 28.2292 72.4689 27.6062 72.7554 27.0752C73.042 26.5441 73.528 26.1485 74.1067 25.9753C74.6853 25.8022 75.3091 25.8657 75.8408 26.1519V17.5502L73.6798 16.3309C73.1481 16.0447 72.752 15.5593 72.5786 14.9814C72.4053 14.4035 72.4689 13.7805 72.7554 13.2494C73.042 12.7183 73.528 12.3227 74.1067 12.1496C74.6853 11.9764 75.3091 12.04 75.8408 12.3262V2.27743C75.8408 1.67342 75.6006 1.09415 75.1729 0.667046C74.7453 0.239944 74.1653 0 73.5605 0C72.9558 0 72.3758 0.239944 71.9481 0.667046C71.5205 1.09415 71.2803 1.67342 71.2803 2.27743V84.1073L75.8408 81.4655V72.8533L73.6798 71.634C73.1682 71.3369 72.7922 70.8527 72.6315 70.2838C72.4707 69.715 72.5377 69.1059 72.8183 68.5855C73.0989 68.065 73.5711 67.6739 74.1351 67.4948C74.6991 67.3157 75.3108 67.3627 75.8408 67.6257V59.0275L73.6798 57.8082C73.419 57.6611 73.1898 57.464 73.0052 57.2283C72.8207 56.9926 72.6845 56.723 72.6043 56.4347C72.5242 56.1464 72.5017 55.8452 72.5381 55.5482C72.5746 55.2512 72.6693 54.9643 72.8168 54.7039Z'
      fill='url(#paint6_linear_1870_1774)'
    />
    <path
      d='M72.8167 13.2302C72.6688 13.4902 72.5738 13.7769 72.5371 14.0737C72.5005 14.3705 72.5229 14.6716 72.6031 14.9597C72.6832 15.2478 72.8196 15.5173 73.0044 15.7526C73.1892 15.9879 73.4186 16.1845 73.6797 16.331L75.8407 17.5503L94.7634 28.2297V22.9951L75.9214 12.3507L75.8407 12.3122C75.3157 12.0445 74.7072 11.9905 74.1432 12.1618C73.5792 12.333 73.1037 12.716 72.8167 13.2302Z'
      fill='#CCCCCC'
    />
    <path
      d='M75.8404 26.1519C75.3087 25.8657 74.6849 25.8022 74.1063 25.9753C73.5277 26.1485 73.0416 26.5441 72.755 27.0752C72.4685 27.6062 72.4049 28.2292 72.5782 28.8071C72.7516 29.385 73.1477 29.8705 73.6794 30.1567L75.8404 31.376L94.7631 42.0519V36.8208L75.9211 26.1905L75.8404 26.1519Z'
      fill='#CCCCCC'
    />
    <path
      d='M99.3242 53.7263V55.6043C99.4577 55.3092 99.5267 54.9891 99.5267 54.6653C99.5267 54.3415 99.4577 54.0214 99.3242 53.7263Z'
      fill='#CCCCCC'
    />
    <path
      d='M75.841 39.9743C75.311 39.7112 74.6993 39.6643 74.1353 39.8434C73.5713 40.0225 73.0991 40.4136 72.8185 40.934C72.5379 41.4545 72.4709 42.0635 72.6316 42.6324C72.7924 43.2013 73.1684 43.6855 73.68 43.9826L75.841 45.2019L94.7637 55.8778V50.6467L75.9217 40.0304L75.841 39.9743Z'
      fill='#CCCCCC'
    />
    <path
      d='M75.9217 53.842L75.841 53.8C75.311 53.5369 74.6993 53.49 74.1353 53.6691C73.5713 53.8482 73.0991 54.2393 72.8185 54.7597C72.5379 55.2802 72.4709 55.8892 72.6316 56.4581C72.7924 57.027 73.1684 57.5112 73.68 57.8083L75.841 59.0276L94.7637 69.7035V64.4724L75.9217 53.842Z'
      fill='#CCCCCC'
    />
    <path
      d='M72.8171 68.5296C72.6696 68.79 72.5749 69.0769 72.5384 69.3739C72.502 69.6708 72.5245 69.9721 72.6046 70.2603C72.6847 70.5486 72.821 70.8183 73.0055 71.054C73.1901 71.2897 73.4193 71.4868 73.6801 71.6339L75.8411 72.8532L83.38 77.1068L87.9581 74.4579L75.9218 67.6677C75.896 67.6516 75.869 67.6375 75.8411 67.6256C75.3178 67.3568 74.7106 67.3007 74.1468 67.4693C73.583 67.6378 73.1065 68.0178 72.8171 68.5296Z'
      fill='#CCCCCC'
    />
    <path
      style={{ mixBlendMode: 'screen' }}
      d='M72.8167 13.2302C72.6688 13.4902 72.5738 13.7769 72.5371 14.0737C72.5005 14.3705 72.5229 14.6716 72.6031 14.9597C72.6832 15.2478 72.8196 15.5173 73.0044 15.7526C73.1892 15.9879 73.4186 16.1845 73.6797 16.331L75.8407 17.5503L94.7634 28.2297V22.9951L75.9214 12.3507L75.8407 12.3122C75.3157 12.0445 74.7072 11.9905 74.1432 12.1618C73.5792 12.333 73.1037 12.716 72.8167 13.2302Z'
      fill='url(#paint7_linear_1870_1774)'
    />
    <path
      style={{ mixBlendMode: 'screen' }}
      d='M75.8404 26.1519C75.3087 25.8657 74.6849 25.8022 74.1063 25.9753C73.5277 26.1485 73.0416 26.5441 72.755 27.0752C72.4685 27.6062 72.4049 28.2292 72.5782 28.8071C72.7516 29.385 73.1477 29.8705 73.6794 30.1567L75.8404 31.376L94.7631 42.0519V36.8208L75.9211 26.1905L75.8404 26.1519Z'
      fill='url(#paint8_linear_1870_1774)'
    />
    <path
      style={{ mixBlendMode: 'screen' }}
      d='M75.841 39.9743C75.311 39.7112 74.6993 39.6643 74.1353 39.8434C73.5713 40.0225 73.0991 40.4136 72.8185 40.934C72.5379 41.4545 72.4709 42.0635 72.6316 42.6324C72.7924 43.2013 73.1684 43.6855 73.68 43.9826L75.841 45.2019L94.7637 55.8778V50.6467L75.9217 40.0304L75.841 39.9743Z'
      fill='url(#paint9_linear_1870_1774)'
    />
    <path
      style={{ mixBlendMode: 'screen' }}
      d='M75.9217 53.842L75.841 53.8C75.311 53.5369 74.6993 53.49 74.1353 53.6691C73.5713 53.8482 73.0991 54.2393 72.8185 54.7597C72.5379 55.2802 72.4709 55.8892 72.6316 56.4581C72.7924 57.027 73.1684 57.5112 73.68 57.8083L75.841 59.0276L94.7637 69.7035V64.4724L75.9217 53.842Z'
      fill='url(#paint10_linear_1870_1774)'
    />
    <path
      style={{ mixBlendMode: 'screen' }}
      d='M72.8171 68.5296C72.6696 68.79 72.5749 69.0769 72.5384 69.3739C72.502 69.6708 72.5245 69.9721 72.6046 70.2603C72.6847 70.5486 72.821 70.8183 73.0055 71.054C73.1901 71.2897 73.4193 71.4868 73.6801 71.6339L75.8411 72.8532L83.38 77.1068L87.9581 74.4579L75.9218 67.6677C75.896 67.6516 75.869 67.6375 75.8411 67.6256C75.3178 67.3568 74.7106 67.3007 74.1468 67.4693C73.583 67.6378 73.1065 68.0178 72.8171 68.5296Z'
      fill='url(#paint11_linear_1870_1774)'
    />
    <path
      d='M99.3242 53.7264V26.9403V12.2596C99.3242 11.6556 99.084 11.0763 98.6563 10.6492C98.2287 10.2221 97.6487 9.98218 97.0439 9.98218C96.4392 9.98218 95.8592 10.2221 95.4315 10.6492C95.0039 11.0763 94.7637 11.6556 94.7637 12.2596V70.5128L99.3242 67.8745V53.7194V53.7264Z'
      fill='#999999'
    />
    <path
      style={{ mixBlendMode: 'multiply' }}
      opacity='0.4'
      d='M99.3242 53.7264V26.9403V12.2596C99.3242 11.6556 99.084 11.0763 98.6563 10.6492C98.2287 10.2221 97.6487 9.98218 97.0439 9.98218C96.4392 9.98218 95.8592 10.2221 95.4315 10.6492C95.0039 11.0763 94.7637 11.6556 94.7637 12.2596V70.5128L99.3242 67.8745V53.7194V53.7264Z'
      fill='url(#paint12_linear_1870_1774)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_1870_1774'
        x1='60.5033'
        y1='101.721'
        x2='60.5033'
        y2='-52.2619'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#555555' />
        <stop offset='0.452242' stopColor='#999999' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_1870_1774'
        x1='87.123'
        y1='45.4261'
        x2='97.5283'
        y2='24.586'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#999999' />
        <stop offset='0.46' stopColor='#999999' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_1870_1774'
        x1='113.767'
        y1='55.0053'
        x2='76.4032'
        y2='34.1361'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#999999' />
        <stop offset='0.46' stopColor='#999999' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_1870_1774'
        x1='33.8629'
        y1='44.6623'
        x2='24.3774'
        y2='27.7572'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#999999' />
        <stop offset='0.46' stopColor='#999999' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_1870_1774'
        x1='50.6246'
        y1='30.0552'
        x2='-4.02743'
        y2='62.7489'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#999999' />
        <stop offset='0.46' stopColor='#999999' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_1870_1774'
        x1='70.0068'
        y1='42.0519'
        x2='76.0408'
        y2='42.0519'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#999999' />
        <stop offset='0.46' stopColor='#999999' stopOpacity='0.52' />
      </linearGradient>
      <linearGradient
        id='paint6_linear_1870_1774'
        x1='78.8893'
        y1='42.0519'
        x2='71.0101'
        y2='42.0519'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0.42' stopColor='#999999' stopOpacity='0.7' />
        <stop offset='0.62' stopColor='#999999' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint7_linear_1870_1774'
        x1='85.3757'
        y1='18.0233'
        x2='82.5989'
        y2='22.7704'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#999999' />
        <stop offset='0.49' stopColor='#999999' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint8_linear_1870_1774'
        x1='85.6315'
        y1='31.3164'
        x2='81.8184'
        y2='38.0337'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#999999' />
        <stop offset='0.49' stopColor='#999999' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint9_linear_1870_1774'
        x1='85.7935'
        y1='41.9049'
        x2='78.8876'
        y2='63.9763'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#999999' />
        <stop offset='0.34' stopColor='#999999' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint10_linear_1870_1774'
        x1='85.4181'
        y1='58.6527'
        x2='82.1798'
        y2='65.7158'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#999999' />
        <stop offset='0.49' stopColor='#999999' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint11_linear_1870_1774'
        x1='81.7031'
        y1='68.9571'
        x2='77.078'
        y2='77.8753'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#999999' />
        <stop offset='0.49' stopColor='#999999' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint12_linear_1870_1774'
        x1='100.092'
        y1='40.251'
        x2='96.4861'
        y2='40.251'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0.24' stopColor='#999999' stopOpacity='0.7' />
        <stop offset='0.52' stopColor='#999999' stopOpacity='0' />
      </linearGradient>
    </defs>
  </svg>
);
